import { GetStaticProps, NextPage } from 'next';
import { Container, Row, Col } from 'reactstrap';
import { Client } from '../utils';
import { Layout, SeoMeta } from '../components/Layout';
import { Section } from '../components/Sections';
import { BenefitsSection } from '../components/Benefits';
import { HeroImage, ImageComponent } from '../components/Media';
import { ImageTextSection } from '../components/Sections';
import { RichText } from 'prismic-reactjs';

interface Props {
  content?: any;
}

const Amenities: NextPage<Props> = ({ content }) => {
  return (
    <Layout>
      <SeoMeta
        title={RichText.asText(content.seo__title)}
        desc={RichText.asText(content.seo__description)}
        socialImage={content.seo__image}
      />
      {content.hero_image && content.hero_image.url && (
        <Section hasBottom={false}>
          <Container fluid>
            <HeroImage
              src={content.hero_image.url}
              alt={content.hero_image.alt}
              priority={true}
            />
          </Container>
        </Section>
      )}

      {(content.icon !== '' ||
        (content.subheadline && RichText.asText(content.subheadline) !== '') ||
        (content.text_left && RichText.asText(content.text_left) !== '') ||
        (content.text_right && RichText.asText(content.text_right) !== '')) && (
        <Section hasTop>
          <Container fluid>
            <Row>
              {/* <Col md={6} lg={4}>
                <Icon type={content.icon} />
                <h2 className="font--lg font--secondary font--bold">
                  {RichText.asText(content.subheadline)}
                </h2>
                {RichText.render(content.text_left)}
              </Col> */}
              <Col
                md={{
                  size: 6,
                  offset: 6,
                }}
                className="m-t-12 m-t"
              >
                <>
                  <h1 className="font--xxl font--primary">
                    Work. Play.
                    <br />
                    Relax.
                  </h1>
                  {RichText.render(content.text_right)}
                </>
              </Col>
            </Row>
          </Container>
        </Section>
      )}

      {/* {content.iframe_link.url !== '' && (
        <IFrame src={Link.url(content.iframe_link)} />
      )} */}

      {content.full_image && content.full_image.url && (
        <Section>
          <Container fluid>
            <ImageComponent
              src={content.full_image.url}
              alt={content.full_image.alt}
              width={content.full_image.dimensions.width * 2}
              height={content.full_image.dimensions.height * 2}
              offset="full"
              objectFit="contain"
            />
          </Container>
        </Section>
      )}

      {content.image_text.length > 0 && (
        // @ts-ignore
        <ImageTextSection content={content.image_text} />
      )}

      {(content.benefits_section_1__title[0].text !== '' ||
        content.benefits_section_1__icons.length) > 0 && (
        <BenefitsSection
          title={RichText.asText(content.benefits_section_1__title)}
          backgroundColor="green-light"
          benefits={content.benefits_section_1__icons}
          hasBorder
        />
      )}

      {(content.benefits_section_2__title[0].text !== '' ||
        content.benefits_section_2__icons.length > 0) && (
        <BenefitsSection
          title={RichText.asText(content.benefits_section_2__title)}
          backgroundColor="blue-light"
          benefits={content.benefits_section_2__icons}
          hasBorder
        />
      )}

      {(content.benefits_section_3__title[0].text !== '' ||
        content.benefits_section_3__icons.length > 0) && (
        <BenefitsSection
          title={RichText.asText(content.benefits_section_3__title)}
          backgroundColor="brown-light"
          benefits={content.benefits_section_3__icons}
          hasBorder
        />
      )}

      <Section>
        <Container fluid>
          <Row>
            <Col
              md={{
                size: 6,
                offset: 4,
              }}
            >
              <div className="m-t">
                <p>
                  *Additional fees may apply. Please speak to a Leasing
                  Associate for details.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  // https://prismic.io/docs/technologies/query-by-type-rest-api
  const res = await Client.query('[at(document.type, "amenities")]');
  const data = res.results.map((content: { data: any }) => {
    return content.data;
  });
  const content = data[0];

  return {
    props: {
      content,
    },
  };
};
export default Amenities;
